import hmacsha1 from "crypto-js/hmac-sha1";
import { trim, timestampUTC } from "./utils";
/*
 * @discribe 拼接鉴权头。
 * @method createAuthorization
 * @param {
 *   url:请求的接口url
 *   method:请求方法，大写,
 *   checkMD5: 请求体是否需要md5
 * }
 * @return {String} 返回一个鉴权字符串
 * TODO 未处理对象的字段目前暂未定义完全
 * */
function createAuthorization(url, method, params, header) {
  var authorization = "TSS1-HMAC-SHA1 ";
  // 计算 signedHeaders
  var signedHeaders = "host";
  if (params.data.checkMd5) {
    signedHeaders += ";content-md5";
  }
  for (var key in header) {
    signedHeaders += `;${key}`;
  }
  var signature = createSignature(url, method, params, header);
  authorization += `AccessKeyId=${params.accessKeyId},SignedHeaders=${signedHeaders},Signature=${signature}`;
  return authorization;
}
/*
 * @discribe 生成签名。
 * @method createSignature
 * @param {
 *   url:请求的url包括?和后面的参数
 *   method:请求的方法，大写，如：PUT
 *   parmas:请求的参数
 * }
 * @return {String} 返回一个加密签名字符串
 * */
function createSignature(url, method, params, header) {
  var queryString = "";
  var canonicalQueryString = "";
  // 判断URL中是否有参数
  if (url.indexOf("?") > -1 && url.split("?")[1]) {
    queryString = url.split("?")[1];
    canonicalQueryString = getCanonicalQueryString(queryString);
  }
  var uri = url.split("?")[0];
  var canonicalHeaders = getCanonicalHeaders(header);
  var canonicalRequest = `${method}\n${uri}\n${canonicalQueryString}\n${canonicalHeaders}`;
  var dateStr = timestampUTC(header["x-tss-date"]);

  var stringToSign = `TSS1-HMAC-SHA1\n${dateStr}\n${canonicalRequest}`;
  var signature = hmacsha1(stringToSign, params.accessKeySecret);
  return signature;
}
/*
 * @discribe 获取CanonicalQueryString。
 * @method getCanonicalQueryString
 * @param {
 *   data: 请求参数
 * }
 * @return {String} 返回一个排序后的字符串
 * */
function getCanonicalQueryString(queryParam) {
  var queryArr = queryParam.split("&").sort();
  var queryString = "";

  for (let i = 0; i < queryArr.length; i++) {
    var arr = queryArr[i].split("=");
    queryString += `${encodeURIComponent(arr[0])}=${encodeURIComponent(
      arr[1],
    )}&`;
  }

  queryString = queryString.slice(0, queryString.length - 1);
  return queryString;
}
/*
 * @discribe 获取getCanonicalHeaders。
 * @method getCanonicalHeaders
 * @param {
 *   headers: 请求头对象
 * }
 * @return {String} 返回一个排序后的字符串
 * */
function getCanonicalHeaders(header) {
  var newHeader = {
    host: "upload.xueersi.com",
  };
  for (var key in header) {
    newHeader[key.toLowerCase()] = header[key];
  }
  var newKey = Object.keys(newHeader).sort();
  var queryString = "";
  for (let i = 0; i < newKey.length; i++) {
    queryString += `${newKey[i]}:${trim(newHeader[newKey[i]])}\n`;
  }

  return queryString;
}

export default createAuthorization;
